import { DefaultButton, Icon, Spinner } from '@fluentui/react';
import { observer } from 'mobx-react';
import { useState } from 'react';

interface TemplateResyncButtonProps {
	syncTemplate: () => Promise<void>;
}

function TemplateResyncButton({ syncTemplate }: TemplateResyncButtonProps) {
	const [isSyncing, setIsSyncing] = useState(false);
	const [hasSynced, setHasSynced] = useState(false);

	return (
		<DefaultButton
			text="Re-sync"
			onRenderIcon={() =>
				isSyncing ? (
					<Spinner style={{ marginLeft: '5px' }} />
				) : (
					<Icon iconName="Refresh" />
				)
			}
			styles={{
				flexContainer: {
					flexDirection: 'row-reverse',
				},
			}}
			onClick={() => {
				setIsSyncing(true);
				syncTemplate()
					.then(() => {
						// We've succeeded, disable the button for now
						setHasSynced(true);
					})
					.finally(() => {
						// Either an error has occurred, or we've succeeded. Either way we need to turn off the spinner
						setIsSyncing(false);
					});
			}}
			disabled={isSyncing || hasSynced}
		/>
	);
}

export default observer(TemplateResyncButton);
